"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTranslations = void 0;
var _i18n = require("@ori/i18n");
/* istanbul ignore file */

/**
 * A hook for accessing translations within a specific namespace along with a formatting function.
 *
 * @returns The translations within the specified namespace and a formatting function.
 */
const useTranslations = () => (0, _i18n.useTranslationsFromNamespace)();
exports.useTranslations = useTranslations;